var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._l((_vm.splitContent(_vm.data.content)),function(line){return [(line.segments)?_vm._l((line.segments),function(segment){return _c('FormattedContent',{attrs:{"data":segment}},[_vm._v(_vm._s(_vm.$t(segment.content)))])}):[_c('FormattedContent',{attrs:{"data":_vm.data}},[_vm._v(_vm._s(_vm.$t(line)))])],_c('br')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }